module.exports = __webpack_public_path__ + "files/8053f28741c5aac359329cc31b07cec3.ttf";


//////////////////
// WEBPACK FOOTER
// ./non_npm_dependencies/google-fonts/fonts/lora-italic-webfont.ttf
// module id = 850
// module chunks = 60